import { render, staticRenderFns } from "./AddEditLinkDetails.vue?vue&type=template&id=485335ca&scoped=true"
import script from "./AddEditLinkDetails.vue?vue&type=script&lang=js"
export * from "./AddEditLinkDetails.vue?vue&type=script&lang=js"
import style0 from "./AddEditLinkDetails.vue?vue&type=style&index=0&id=485335ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485335ca",
  null
  
)

export default component.exports